import { useState, useEffect } from "react";
import { shouldShowWhatsNewModal, markVersionAsSeen } from "./versionUtils";

/**
 * Hook to manage the "What's New" modal state
 *
 * @param {boolean} checkOnMount Whether to check if the modal should be shown on component mount
 * @returns {Object} Object containing modal state and handlers
 */
const useWhatsNewModal = (checkOnMount = true) => {
  const [showModal, setShowModal] = useState(false);

  // Check if we should show the modal on mount
  useEffect(() => {
    if (checkOnMount && shouldShowWhatsNewModal()) {
      setShowModal(true);
    }
  }, [checkOnMount]);

  // Handler to close the modal and mark version as seen
  const handleCloseModal = () => {
    setShowModal(false);
    markVersionAsSeen();
  };

  // Handler to manually show the modal
  const handleShowModal = () => {
    setShowModal(true);
  };

  return {
    showModal,
    handleCloseModal,
    handleShowModal,
  };
};

export default useWhatsNewModal;
